<!-- 医療機関基本マスタ 更新画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wirkn">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>医療機関基本情報マスタ</h2>
			<ul class="contntMenu">
				<li class="onBack" v-on:click="onCancel">TOP</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
					<!--  ↑ contntMenu「TOP」に変更 <button class="cancelBtn" v-on:click="onCancel">キャンセル</button>-->
				</div>
				<table class="inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
					<tr>
						<th>医療機関名称</th>
						<td>
							<ul class="nameH">
								<li><input type="text" placeholder="名称" v-model="inputForm.irnm"></li>
								<li><span>カナ</span><input type="text" maxlength="120" placeholder="名称カナ" v-model="inputForm.irkn"></li>
								<li><span>英字</span><input type="text" maxlength="120" placeholder="名称英字" v-model="inputForm.egnm"></li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>契約先 住所</th>
						<td>
							<ul class="add">
								<li><input type="text" maxlength="3" placeholder="XXX" v-model="inputForm.kzip1">-<input type="text" maxlength="4" placeholder="XXXX" v-model="inputForm.kzip2"><button v-on:click="onKAddressSearch">住所検索</button></li>
								<li><input type="text" placeholder="住所" v-model="inputForm.kad1"></li>
								<li><input type="text" placeholder="住所" v-model="inputForm.kad2"></li>
								<li class="tel"><input type="text" maxlength="20" placeholder="XX-XXXX-XXXX" v-model="inputForm.ktel"></li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>受診先 住所</th>
						<td>
							<ul class="add">
								<li><input type="text" maxlength="3" placeholder="XXX" v-model="inputForm.fzip1">-<input type="text" maxlength="4" placeholder="XXXX" v-model="inputForm.fzip2"><button v-on:click="onFAddressSearch">住所検索</button></li>
								<li><input type="text" placeholder="住所" v-model="inputForm.fad1"></li>
								<li><input type="text" placeholder="住所" v-model="inputForm.fad2"></li>
								<li class="tel"><input type="text" maxlength="20" placeholder="XX-XXXX-XXXX" v-model="inputForm.ftel"></li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>電話予約受付時間</th>
						<td>
							<input type="text" placeholder="電話予約受付時間" v-model="inputForm.uktk">
						</td>
					</tr>
					<tr>
						<th>予約区分</th>
						<td>
							<ul class="radioLst">
								<li><label for="nwkbKH" class="radio"><input type="radio" id="nwkbKH" v-bind:value="inputForm.codeNwkbKH" v-model="inputForm.nwkb"><span>個人+健保</span></label></li>
								<li><label for="nwkbKojin" class="radio"><input type="radio" id="nwkbKojin" v-bind:value="inputForm.codeNwkbKojin" v-model="inputForm.nwkb"><span>個人</span></label></li>
								<li><label for="nwkbHealth" class="radio"><input type="radio" id="nwkbHealth" v-bind:value="inputForm.codeNwkbHealth" v-model="inputForm.nwkb"><span>健保</span></label></li>
							</ul>
						</td>
					</tr>
					<tr>
						<th>
							カレンダー形式
						</th>
						<td>
							<ul class="radioLst">
								<li><label for="clndC" class="radio"><input type="radio" id="clndC" v-bind:value="inputForm.codeClndC" v-model="inputForm.clnd"><span>カレンダー形式</span></label></li>
								<li><label for="clndL" class="radio"><input type="radio" id="clndL" v-bind:value="inputForm.codeClndL" v-model="inputForm.clnd"><span>一覧形式</span></label></li>
							</ul>
						</td>
					</tr>
						<tr>
							<th>予約変更・キャンセル可能日</th>
							<td>
								<span class="attetion">※受診予定日の何日前までがweb予約可能か設定</span>受診予定日の <input type="text" class="date" maxlength="2" placeholder="XX" v-model="inputForm.chdy"> 日前まで
							</td>
						</tr>
						<tr>
							<th>予約可能期間</th>
							<td><span class="attetion">※何日後～何日後までがweb予約可能か設定</span>
								<input type="text" class="date" maxlength="3" placeholder="XXX" v-model="inputForm.stdy"> 日後 ～ <input type="text" class="date" maxlength="3" placeholder="XXX" v-model="inputForm.eddy"> 日後まで
							</td>
						</tr>
						<tr>
							<th>初期パスワードルール</th>
							<td>
								<ul class="radioLst">
									<li><label for="passwordBirth" class="radio"><input type="radio" id="passwordBirth" v-bind:value="inputForm.codePasswordBirth" v-model="inputForm.pass"><span>生年月日</span></label></li>
									<li><label for="passwordRandam" class="radio"><input type="radio" id="passwordRandam" v-bind:value="inputForm.codePasswordRandam" v-model="inputForm.pass"><span>ランダム</span></label></li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>ホームページ背景</th>
							<td>
								<!--<input type="text" placeholder="ホームページ背景" v-model="inputForm.hmpg">-->
								<div v-if="inputForm.hmpgFlag">登録済みです</div>
								<div v-else>未登録です</div>
								<input type="file" v-on:change="onHmpgFileChange">
							</td>
						</tr>
						<tr>
							<th>施設ホームページURL</th>
							<td><input type="text" placeholder="施設ホームページURL" v-model="inputForm.url"></td>
						</tr>
						<tr>
							<th>消費税扱い</th>
							<td>
								<ul class="groupLi">
									<li>
										<label for="taxkOut" class="radio"><input type="radio" id="taxkOut" v-bind:value="inputForm.codeTaxkOut" v-model="inputForm.taxk"><span>外税</span></label>
										<label for="taxkIn" class="radio"><input type="radio" id="taxkIn" v-bind:value="inputForm.codeTaxkIn" v-model="inputForm.taxk"><span>内税</span></label>
									</li>
									<li>
										<label for="taxcUp" class="radio"><input type="radio" id="taxcUp" v-bind:value="inputForm.codeTaxcUp" v-model="inputForm.taxc"><span>切り捨て</span></label>
										<label for="taxc45" class="radio"><input type="radio" id="taxc45" v-bind:value="inputForm.codeTaxc45" v-model="inputForm.taxc"><span>切り上げ</span></label>
										<label for="taxcDown" class="radio"><input type="radio" id="taxcDown" v-bind:value="inputForm.codeTaxcDown" v-model="inputForm.taxc"><span>四捨五入</span></label>
									</li>
								</ul>
							</td>
						</tr>
						<tr>
							<th>受診コースない場合の文書</th>
							<td><textarea placeholder="受診コースない場合の文書" v-model="inputForm.erms"></textarea></td>
						</tr>
						<tr>
							<th>インターネット規約文書</th>
							<td><textarea placeholder="インターネット規約文書" v-model="inputForm.cvtn"></textarea></td>
						</tr>
					</tbody>
				</table>

			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WIRKNUpdateApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'
	var YubinBango = require('yubinbango-core2')

	export default {
		// モジュール名
		name: 'MasterWIRKNUpdate',
		// 使用コンポーネント
		components: {
			// エラー表示コンポーネント
			'errorMessageBox': ErrorMessageBox,
			// モーダルウィンドウ表示コンポーネント
			'modalWindow': ModalWindow
		},
		// データ
		data() {
			return {
				// 入力フォーム
				inputForm: {
					// 医療機関名称
					irnm: '',
					// 医療機関カナ名称
					irkn: '',
					// 医療機関英字名称
					egnm: '',

					// 契約先
					// 郵便番号１
					kzip1: '',
					// 郵便番号２
					kzip2: '',
					// 住所１
					kad1: '',
					// 住所２
					kad2: '',
					// 電話番号
					ktel: '',

					// 受診先
					// 郵便番号１
					fzip1: '',
					// 郵便番号２
					fzip2: '',
					// 住所１
					fad1: '',
					// 住所２
					fad2: '',
					// 電話番号
					ftel: '',

					// 電話予約受付時間
					uktk: '',
					// 予約区分(1:個人予約＋健保予約 2:個人予約 3:健保予約)
					nwkb: '',
					codeNwkbKH: '1',
					codeNwkbKojin: '2',
					codeNwkbHealth: '3',
					// カレンダー形式（1:カレンダー形式、2:一覧形式）
					clnd: '',
					codeClndC: '1',
					codeClndL: '2',
					// 予約変更・キャンセル許可「　」日前まで可能
					chdy: '',
					// 予約可能期間開始　「　」日後～
					stdy: '',
					// 予約可能期間終了　～「　」日後
					eddy: '',
					// 初期パスワードルール(1:生年月日 2:ランダム)
					pass: '',
					codePasswordBirth: '1',
					codePasswordRandam: '2',
					// ホームページ背景
					hmpgFlag: false,
					// ファイル名
					hmpgFileName: '',
					// ファイルサイズ
					hmpgFileSize: 0,
					// base64変換されたファイルデータ
					hmpgFileDataBase64: '',

					// ホームページＵＲＬ
					url: '',
					// 消費税区分(1:外税 2:内税)
					taxk: '',
					codeTaxkOut: '1',
					codeTaxkIn: '2',
					// 消費税小数点扱い(1:切り捨て 2:切り上げ 3:四捨五入)
					taxc: '',
					codeTaxcUp: '1',
					codeTaxc45: '2',
					codeTaxcDown: '3',
					// 受診コースない場合の文章
					erms: '',
					// インターネット規約文章
					cvtn: '',
				},
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルフック: created
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWIRKN::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('MasterWIRKN::created End')
		},
		methods: {
			// 表示系--------------------------------------------------S
			// 初期表示
			firstDisplay: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::firstDisplay Start')

				WIRKNUpdateApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd 
				}).then(({ responce }) => {
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.inputForm.irnm = responce.data.irnm
						this.inputForm.irkn = responce.data.irkn
						this.inputForm.egnm = responce.data.egnm
						// 契約先
						this.inputForm.kzip1 = responce.data.kzip1
						this.inputForm.kzip2 = responce.data.kzip2
						this.inputForm.kad1 = responce.data.kad1
						this.inputForm.kad2 = responce.data.kad2
						this.inputForm.ktel = responce.data.ktel
						// 受診先
						this.inputForm.fzip1 = responce.data.fzip1
						this.inputForm.fzip2 = responce.data.fzip2
						this.inputForm.fad1 = responce.data.fad1
						this.inputForm.fad2 = responce.data.fad2
						this.inputForm.ftel = responce.data.ftel

						this.inputForm.uktk = responce.data.uktk
						this.inputForm.nwkb = responce.data.nwkb
						this.inputForm.clnd = responce.data.clnd

						this.inputForm.chdy = responce.data.chdy
						this.inputForm.stdy = responce.data.stdy
						this.inputForm.eddy = responce.data.eddy
						this.inputForm.pass = responce.data.pass
						this.inputForm.hmpgFlag = responce.data.hmpgFlag
						this.inputForm.url = responce.data.url
						this.inputForm.taxk = responce.data.taxk
						this.inputForm.taxc = responce.data.taxc

						this.inputForm.erms = responce.data.erms
						this.inputForm.cvtn = responce.data.cvtn

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKN::firstDisplay End')
				})
			},
			// 表示系--------------------------------------------------E
			// イベント系--------------------------------------------------S
			onUpdate: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onUpdate Start')

				var tempChdy = this.checkNumber(this.inputForm.chdy)
				var tempStdy = this.checkNumber(this.inputForm.stdy)
				var tempEddy = this.checkNumber(this.inputForm.eddy)

				WIRKNUpdateApi.Update({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					irnm: this.inputForm.irnm,
					irkn: this.inputForm.irkn,
					egnm: this.inputForm.egnm,
					kzip1: this.inputForm.kzip1,
					kzip2: this.inputForm.kzip2,
					kad1: this.inputForm.kad1,
					kad2: this.inputForm.kad2,
					ktel: this.inputForm.ktel,
					fzip1: this.inputForm.fzip1,
					fzip2: this.inputForm.fzip2,
					fad1: this.inputForm.fad1,
					fad2: this.inputForm.fad2,
					ftel: this.inputForm.ftel,
					uktk: this.inputForm.uktk,
					nwkb: this.inputForm.nwkb,
					clnd: this.inputForm.clnd,
					chdy: tempChdy,
					stdy: tempStdy,
					eddy: tempEddy,
					pass: this.inputForm.pass,
					//hmpg: this.inputForm.hmpg,
					hmpgFileName: this.inputForm.hmpgFileName,
					hmpgFileSize: this.inputForm.hmpgFileSize,
					hmpgFileDataBase64: this.inputForm.hmpgFileDataBase64,
					url: this.inputForm.url,
					taxk: this.inputForm.taxk,
					taxc: this.inputForm.taxc,
					erms: this.inputForm.erms,
					cvtn: this.inputForm.cvtn,
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 更新が正常に成功した場合
						// ストアの医療機関名を更新する
						this.$store.commit(
							types.ADMIN_USERCHOICE_WIRKN,
							{
								irnm: this.inputForm.irnm
							}
						)
						// 更新ダイアログを閉じる
						this.onConfirmUpdateModalClose()
						// 更新完了画面に遷移
						this.$router.push('/MasterWIRKNUpdateDone')

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {

						this.onValidationErrorModalOpen(responce.data.errorMessagesList)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
						// エラーメッセージリストを作成し、エラーを表示
						var errorMessagesList = []
						errorMessagesList.push(responce.data.errorMessage)
						this.onValidationErrorModalOpen(errorMessagesList)
						
					} else if (
						responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKN::onUpdate End')
				})
			},
			// キャンセルボタン押下時
			onCancel: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onCancel Start')

				// メニューへ戻る
				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog('MasterWIRKN::onCancel End')
			},
			// 郵便番号から契約先住所検索
			onKAddressSearch: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onKAddressSearch Start')

				// :TODO　共通のチェック関数を作る
				var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)

				if (this.inputForm.kzip1.length != 3
						|| !regexp.test(this.inputForm.kzip1)) {
					return
				}

				if (this.inputForm.kzip2.length != 4
					|| !regexp.test(this.inputForm.kzip2)) {
					return
				}

				var tempZip = this.inputForm.kzip1 + '- ' + this.inputForm.kzip2
				
				new YubinBango.Core(tempZip,(addr) => {
					if (addr.region_id) {
						this.inputForm.kad1 = addr.region + addr.locality + addr.street;
					}
					UtilityConsoleLog.consoleLog('MasterWIRKN::onKAddressSearch End')
				})
			},
			// 郵便番号から受診先住所検索
			onFAddressSearch: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onFAddressSearch Start')

				// :TODO　共通のチェック関数を作る
				var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)

				if (this.inputForm.fzip1.length != 3
					|| !regexp.test(this.inputForm.fzip1)) {
					return
				}

				if (this.inputForm.fzip2.length != 4
					|| !regexp.test(this.inputForm.fzip2)) {
					return
				}

				var tempZip = this.inputForm.fzip1 + '- ' + this.inputForm.fzip2

				new YubinBango.Core(tempZip, (addr) => {
					if (addr.region_id) {
						this.inputForm.fad1 = addr.region + addr.locality + addr.street;
					}
					UtilityConsoleLog.consoleLog('MasterWIRKN::onFAddressSearch End')
				})
			},
			// ホームページ背景画像に変更があったときのイベントを処理する
			// ファイルをbase64にエンコードして保存する
      onHmpgFileChange(e) {

        const reader = new FileReader()
        let files = e.target.files
  
        // name: ファイル名
        // size: ファイルサイズ
        // type: ファイル種類（image/jpeg,image/png,text/plainなど）（未使用）
        var tempUploadFile = files[0]

        this.inputForm.hmpgFileName = tempUploadFile.name
        this.inputForm.hmpgFileSize = tempUploadFile.size
  
        reader.readAsDataURL(tempUploadFile)
  
        reader.onload = () => {
          this.inputForm.hmpgFileDataBase64 = reader.result
        }
      },
			// イベント系--------------------------------------------------E
			// その他--------------------------------------------------S
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWIRKN::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWIRKN::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			onValidationErrorModalOpen: function (errorMessages) {

				UtilityConsoleLog.consoleLog('MasterWIRKN::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKN::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKN::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {

				UtilityConsoleLog.consoleLog('MasterWIRKN::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWIRKN::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルを閉じる
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKN::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWIRKN::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalOpen Start')

				// 整数型の型を確認する
				var tempChdy = this.checkNumber(this.inputForm.chdy)
				var tempStdy = this.checkNumber(this.inputForm.stdy)
				var tempEddy = this.checkNumber(this.inputForm.eddy)

				if (tempChdy == -1) {
					this.onValidationErrorModalOpen(['予約変更・キャンセル可能日は整数で入力してください。'])
					return
				}

				if (tempStdy == -1 || tempEddy == -1) {
					this.onValidationErrorModalOpen(['予約可能期間は整数で入力してください。'])
					return
				}

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {

				UtilityConsoleLog.consoleLog('MasterWIRKN::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWIRKN::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {

				UtilityConsoleLog.consoleLog('MasterWIRKN::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWIRKN::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
			// その他--------------------------------------------------E
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKN/MasterWIRKNUpdate.vue